<style>
.mypos-container {
    background-color: #fff;
    position: absolute!important;
    top: 32px;
    left: 1px;
    z-index: 1000;
    width: 100% ;
    border-radius: 2px;
    border-top: 1px solid #d9d9d9;
    font-family: Arial,sans-serif;
    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
}

.mypos-container.mypos-logo {
    z-index: 99999999;
}

.mypos-item {
    cursor: default;
    padding: 0 4px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 30px;
    text-align: left;
    border-top: 1px solid #e6e6e6;
    font-size: 11px;
    color: #999;
}

.mypos-icon-marker {
    background-position: -1px -161px;
}

.mypos-icon {
    width: 15px;
    height: 20px;
    margin-right: 7px;
    margin-top: 6px;
    display: inline-block;
    vertical-align: top;
    background-image: url(https://maps.gstatic.com/mapfiles/api-3/images/autocomplete-icons.png);
    background-size: 34px;
}

.mypos-item-query {
    font-size: 13px;
    padding-right: 3px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.3px;
    color: rgba(74, 74, 74, 0.9);
}
</style>

<script>
    import {Form} from '../../helpers/Form/Form'
    export default {
        props: {
            source: String
        },
        data() {
            return {
                city: null,
                totalCount: null,
                municipalities: [],
                municipality: [
                    name = ''
                ],
                search_string: '',
                search_string_label: '',
                message: '',
                coords: [],
                inputType: true,
                requiredWhere: false,
            }
        },
        created() {

        },
        mounted() {

            this.search_string = this.getParameterByName('search_string')

            $(".search__jumbotron").keyup(function (event) {
                event.preventDefault();
                if (event.keyCode == 13) {
                    $(".invitation-search-button").click();
                }
            });

            let initialData = []
            let municipality = this.getParameterByName('municipality')
            if (municipality && municipality.length && municipality != 'null') {
                this.municipality = {name: municipality}
                initialData.push({id: municipality, text: municipality})
            } else {
                this.$refs.mypos.$refs.input.value = 'La mia posizione'
                this.municipality.name = 'La mia posizione'
            }

            let city = this.getParameterByName('city')
            if (!_.isEmpty(city)) {
                this.city = city
            }

            this.coords = [];
            this.coords.push(this.getParameterByName('latitude'));
            this.coords.push(this.getParameterByName('longitude'));

            this.$bus.$on('update-count', (data) => {
                this.totalCount = data.count
            })

            this.getSearchStringLabel()
            this.getLocation()

        },
        methods: {
            getSearchStringLabel() {
                if (_.isObject(this.municipality)) {
                    this.search_string_label = `${this.search_string} ${this.municipality.name}`
                } else {
                    this.search_string_label = this.search_string
                }
            },
            onSearch() {
                if(this.coords.length === 0 && this.requiredWhere === true) {
                    alert('Attenzione: Occorre selezionare un luogo, per poter effettuare la ricerca!')
                    return false
                }

                if(this.coords.length === 0)
                    this.getLocation()

                if(_.isEmpty(this.municipality.name) || _.isEmpty(this.$refs.mypos.$refs.input.value)) {
                    this.$refs.mypos.$refs.input.value = 'La mia posizione'
                    this.municipality.name = 'La mia posizione'
                }

                let municipality = this.municipality ? this.municipality.name : ''
                let latitude = this.coords[0]
                let longitude = this.coords[1]

                let queryString = `${this.source}?search_string=${this.search_string}&municipality=${municipality}&latitude=${latitude}&longitude=${longitude}`

                location.href = queryString
            },
            setPlace(place) {
                if (place) {
                    this.coords = [];
                    this.coords.push(place.geometry.location.lat());
                    this.coords.push(place.geometry.location.lng());
                    let city = _.head(place.address_components.filter(i => i.types.includes('locality')))
                    if (!_.isEmpty(city)) {
                        this.city = city.long_name
                    }
                    this.municipality = { name: place.formatted_address };
                }
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, '\\$&');

                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);

                if (!results) return '';
                if (!results[2]) return '';

                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
            returnPosition(position) {
                if(this.coords.length === 0) {
                    this.coords = [];
                    this.coords.push(position.coords.latitude);
                    this.coords.push(position.coords.longitude);
                    this.$bus.$emit('geolocalizated', {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                }

                this.requiredWhere = false;
            },
            errorPosition(error) {
                this.requiredWhere = true;
            },
            getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.returnPosition, this.errorPosition);
                }
            },
            onFocus(action) {
                if(this.$refs.mypos.$refs.input.value === '' && this.requiredWhere == false)
                    this.inputType = action
            },
            onBlur() {
                setTimeout(() => this.inputType = true, 200);
            },
            changeAddress() {
                if(this.$refs.mypos.$refs.input.value !== '')
                    this.inputType = true
                else if(this.requiredWhere == false) {
                    this.inputType = false
                    this.coords = []
                    this.getLocation()
                } else
                   this.coords = []

            },
            setMyPosition() {
                this.getLocation()
                this.$refs.mypos.$refs.input.value = 'La mia posizione'
                this.municipality.name = 'La mia posizione'
                this.inputType = true
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/SearchViewFormContainer.vue